export default function TestimonialSection() {
  return (
    <section className="w-full bg-background-50">
      <div className="px-6 md:px-10 py-14 md:py-20">
        <div className="max-w-5xl mx-auto">
          <div className="relative bg-foreground-900 rounded-2xl p-8 md:p-12 lg:p-14 overflow-visible">
            <div className="hidden lg:block absolute -left-10 top-1/2 -translate-y-1/2">
              <div className="w-20 h-72 rounded-2xl overflow-hidden">
                <img
                  src="https://readdy.ai/api/search-image?query=Professional%20woman%20in%20modern%20minimal%20office%2C%20cream%20blazer%2C%20warm%20neutral%20background%2C%20soft%20natural%20window%20light%2C%20clean%20editorial%20portrait%2C%20confident%20friendly%20expression%2C%20elegant%20professional%20photography&width=400&height=600&seq=testimonial-v2-hipobuy&orientation=portrait"
                  alt="Utilisatrice Hipobuy Spreadsheet"
                  className="w-full h-full object-cover object-top"
                />
              </div>
            </div>

            <div className="lg:ml-24">
              <div className="text-6xl md:text-7xl font-heading text-accent-400/50 leading-none mb-6 select-none">&ldquo;</div>
              <blockquote className="text-lg md:text-xl lg:text-2xl text-background-50/90 font-light leading-relaxed mb-8">
                Le <strong className="font-semibold text-background-50">hipobuy spreadsheet</strong> a complètement transformé ma façon d'organiser et d'analyser mes données. La structure est intuitive, les fonctionnalités avancées sont impressionnantes, et le gain de temps est considérable au quotidien.
              </blockquote>
              <div className="border-t border-background-50/10 pt-6">
                <p className="text-sm font-semibold text-background-50">Sophie Laurent</p>
                <p className="text-xs text-background-50/50 mt-0.5">Analyste de données, Paris</p>
              </div>
            </div>

            <div className="mt-10 lg:ml-24">
              <a
                href="https://kaspreadsheet.com"
                target="_blank"
                rel="noopener nofollow"
                className="inline-flex items-center gap-2 px-6 py-3 rounded-full bg-accent-500 text-background-50 font-semibold text-sm whitespace-nowrap hover:bg-accent-400 transition-all cursor-pointer"
              >
                Essayez maintenant
                <i className="ri-arrow-right-line"></i>
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}